import { useEffect } from "react";
import { supabase } from "../lib/supabaseClient";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;

    const handleAuth = async () => {
      const { data, error } = await supabase.auth.getSession();

      if (!isMounted) return;

      const session = data?.session;

      if (error || !session?.user) {
        navigate("/auth", { replace: true });
        return;
      }

      const user = session.user;

      // Retry profile fetch (Supabase trigger delay safe)
      const fetchProfile = async (retries = 3) => {
        const { data, error: profileError } = await supabase
          .from("profiles")
          .select("onboarding_complete")
          .eq("id", user.id)
          .single();

        if (data) return data;

        if (profileError && retries === 0) {
          console.warn("Profile fetch failed:", profileError.message);
          return null;
        }

        if (retries > 0) {
          await new Promise((res) => setTimeout(res, 1000));
          return fetchProfile(retries - 1);
        }

        return null;
      };

      const profile = await fetchProfile();

      if (!isMounted) return;

      if (profile?.onboarding_complete) {
        navigate("/dashboard", { replace: true });
      } else {
        navigate("/onboarding", { replace: true });
      }
    };

    handleAuth();

    return () => {
      isMounted = false;
    };
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#030405] flex flex-col items-center justify-center space-y-4">
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
        className="w-10 h-10 border-4 border-emerald-500 border-t-transparent rounded-full"
      />
      <p className="text-slate-400 font-bold text-xs uppercase tracking-[0.3em] animate-pulse">
        Finalizing Sync...
      </p>
    </div>
  );
};

export default AuthCallback;
